import {Button} from '@wandb/weave/components';
import {type IconName} from '@wandb/weave/components/Icon';
import React, {
  cloneElement,
  type JSX,
  type ReactElement,
  useCallback,
  useState,
} from 'react';
import {Modal} from 'semantic-ui-react';

import {DD_PRIVACY_ALLOW} from '../../util/datadog/privacy';

type ModalTriggerButtonProps =
  | {
      modalHeader: string;
      modalContent: JSX.Element;
      modalDataTest?: string;
      buttonIcon: IconName;
      buttonText: string;
      onClick?: () => void;
    }
  | {
      modalHeader: string;
      modalContent: JSX.Element;
      modalDataTest?: string;
      buttonElement: ReactElement;
      onClick?: () => void;
    };

export const ModalTriggerButton = (props: ModalTriggerButtonProps) => {
  const {modalContent, modalHeader, modalDataTest, onClick} = props;
  const [showModal, setShowModal] = useState(false);
  const openModal = useCallback(() => setShowModal(true), [setShowModal]);
  const closeModal = useCallback(() => setShowModal(false), [setShowModal]);

  let button;
  if ('buttonElement' in props) {
    button = cloneElement(props.buttonElement as any, {
      onClick() {
        openModal();
        onClick?.();
      },
    });
  } else {
    const {buttonIcon, buttonText} = props;
    button = (
      <Button
        icon={buttonIcon}
        variant="secondary"
        twWrapperStyles={{display: 'inline'}}
        onClick={() => {
          openModal();
          onClick?.();
        }}>
        {buttonText}
      </Button>
    );
  }

  return (
    <React.Fragment>
      {/* COLUMNS CONFIG */}
      <Modal
        className="small"
        data-test={modalDataTest}
        // Column/parameter names shown here are already exposed via the
        // allowed run selector table.
        data-dd-privacy={DD_PRIVACY_ALLOW}
        trigger={button}
        open={showModal}
        onClose={closeModal}>
        <Modal.Header>{modalHeader}</Modal.Header>
        <Modal.Content>{modalContent}</Modal.Content>
        <Modal.Actions>
          <Button onClick={closeModal}>Close</Button>
        </Modal.Actions>
      </Modal>
    </React.Fragment>
  );
};
